export class ItemDTO {
  public nome!: string;
  public icone!: string;
  public rota!: string;
}

export class SubmenuDTO {
  public nome!: string;
  public icone!: string;
  public rota!: string;   
  public items!: ItemDTO[];
}

export class MenuDTO {
  public nome!: string; 
  public icone!: string;
  public rota!: string;
  public submenus!: SubmenuDTO[];
}
